// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-label[data-v-53dd87f6]{font-weight:500;color:#666;transform:translateY(9px)}.subData[data-v-53dd87f6]{color:#929292;font-size:12px!important;white-space:nowrap}.v-data-table.disabled[data-v-53dd87f6]{opacity:.5;pointer-events:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
